import React from 'react';
import { hydrate, render } from 'react-dom';
import './index.css';
import App from './App.jsx';
import { RecoilRoot } from 'recoil';
import { BrowserRouter as Router } from 'react-router-dom';
import axios from 'axios';

// axios.defaults.baseURL = 'https://cms.connectedbytes.in/';

axios.defaults.baseURL = 'https://emr.metadei.in/wp-json/wp/v2/';

const root = document.getElementById('root');
const AppTree = (
  <Router>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </Router>
);

// add a quick log to be sure we hit this
console.debug('📦 React is about to hydrate:', root.hasChildNodes());

if (root.hasChildNodes()) {
  hydrate(AppTree, root);
} else {
  render(AppTree, root);
}
